var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 217,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0309\\u66F4\\u65B0-space-featured\\u9875\\u9762\\u5907\\u4EFD-3",
    transform: "translate(-708.000000, -699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(348.000000, 682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3\\u5907\\u4EFD",
    transform: "translate(252.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(108.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,18.6666667 L21,19.7777778 C21,21 20,22 18.7777778,22 L3.22222222,22 C1.98888889,22 1,21 1,19.7777778 L1,4.22222222 C1,3 1.98888889,2 3.22222222,2 L18.7777778,2 C20,2 21,3 21,4.22222222 L21,5.33333333 L11,5.33333333 C9.76666667,5.33333333 8.77777778,6.33333333 8.77777778,7.55555556 L8.77777778,16.4444444 C8.77777778,17.6666667 9.76666667,18.6666667 11,18.6666667 L21,18.6666667 Z M11,16.4444444 L22.1111111,16.4444444 L22.1111111,7.55555556 L11,7.55555556 L11,16.4444444 Z M15.4444444,13.6666667 C14.5222222,13.6666667 13.7777778,12.9222222 13.7777778,12 C13.7777778,11.0777778 14.5222222,10.3333333 15.4444444,10.3333333 C16.3666667,10.3333333 17.1111111,11.0777778 17.1111111,12 C17.1111111,12.9222222 16.3666667,13.6666667 15.4444444,13.6666667 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet24Dp);
export default __webpack_public_path__ + "static/media/wallet_24dp.e84f213edb2067bad403eb961aa1a649.svg";
export { ForwardRef as ReactComponent };